"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINK_API_URL = void 0;
exports.LINK_API_URL = "https://www.walletlink.org";